export const OSANO_SCRIPT_URL =
  'https://cmp.osano.com/6orE9TsOo4ADWSUs/3aef598f-6234-432e-aac1-111ca6dcff30/osano.js?language=en';
